import I18n from 'I18n';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Link } from 'foundations-components/transitional/components/Link';
import useFetchContentPrerenderingProgress from 'ContentComponents/hooks/useFetchContentPrerenderingProgress';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, useContentObjectType, contentIsPublished } from 'content-management-data-lib';
import { useContentDetailsDataProvider } from '../providers/ContentDetailsDataProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FREE_DOMAIN_REGEX = /^.+\.hubspotpagebuilder(qa)?(-[A-z0-9]+)?\..+/;
const getShouldPollForContentPrerendingProgress = ({
  contentObject,
  publishDate,
  isContentPrerenderingEnabled
}) => {
  if (contentIsPublished(contentObject) && publishDate && I18n.moment().valueOf() - publishDate <= 120000) {
    const domain = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.DOMAIN);
    const isDomainOnFreePageBuilder = domain ? new RegExp(FREE_DOMAIN_REGEX).test(domain) : false;
    return isContentPrerenderingEnabled || isDomainOnFreePageBuilder;
  }
  return false;
};
const Url = ({
  displayUrl,
  isDisabled = false,
  href
}) => /*#__PURE__*/_jsx(Link, {
  "data-test-id": "page-live-url",
  disabled: isDisabled,
  external: true,
  href: href,
  truncate: true,
  children: displayUrl
});
const UrlWithLoadingSpinner = ({
  id,
  publishDate,
  displayShareablePreviewURL,
  url
}) => {
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    isPolling,
    hasFinishedPrerendering
  } = useFetchContentPrerenderingProgress({
    contentType: contentObjectType,
    id,
    publishDate,
    url
  });
  if (!isPolling && !hasFinishedPrerendering) {
    return /*#__PURE__*/_jsx(Url, {
      displayUrl: url,
      href: displayShareablePreviewURL
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(Url, {
      displayUrl: url,
      href: displayShareablePreviewURL,
      isDisabled: isPolling && !hasFinishedPrerendering
    }), /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "inline",
      showResult: hasFinishedPrerendering,
      size: "xs"
    })]
  });
};
const ContentUrl = ({
  contentDisplayUrl,
  displayShareablePreviewURL
}) => {
  const {
    isContentPrerenderingEnabled,
    contentId,
    contentObject
  } = useContentDetailsDataProvider();
  const publishDate = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.PUBLISH_DATE);
  const shouldPollForContentPrerenderingStatus = getShouldPollForContentPrerendingProgress({
    contentObject,
    publishDate,
    isContentPrerenderingEnabled
  });
  if (!shouldPollForContentPrerenderingStatus) {
    return /*#__PURE__*/_jsx(Url, {
      displayUrl: contentDisplayUrl,
      href: displayShareablePreviewURL
    });
  }
  return /*#__PURE__*/_jsx(UrlWithLoadingSpinner, {
    displayShareablePreviewURL: displayShareablePreviewURL,
    id: contentId,
    publishDate: publishDate,
    url: contentDisplayUrl
  });
};
export default ContentUrl;